import { useEffect } from "react";
import { useAppSelector } from "../store/hooks";

const ModalStack = () => {
  const { modals } = useAppSelector((state) => state.modals);

  useEffect(() => {
    if (modals.length > 0) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modals]);

  return (
    <div>
      {modals.map((modal) => (
        <>{modal}</>
      ))}
    </div>
  );
};

export default ModalStack;
